export default {
    video1: require("../assets/videos/video1.mp4"),
    video2: require("../assets/videos/video2.mp4"),
    video3: require("../assets/videos/video3.mp4"),
    video4: require("../assets/videos/video4.mp4"),
    video5: require("../assets/videos/video5.mp4"),
    video6: require("../assets/videos/video6.mp4"),
    video7: require("../assets/videos/video7.mp4"),
    video8: require("../assets/videos/video8.mp4"),
    video9: require("../assets/videos/video9.mp4"),
    video10: require("../assets/videos/video10.mp4"),
    video11: require("../assets/videos/video11.mp4"),
    video12: require("../assets/videos/video12.mp4"),
    video13: require("../assets/videos/video13.mp4"),
    video14: require("../assets/videos/video14.mp4"),
    video15: require("../assets/videos/video15.mp4"),
    video16: require("../assets/videos/video16.mp4"),
    homepage: require("../assets/images/homepage.mp4"),
}  